import {
  Component,
  ElementRef,
  ViewChild,
  computed,
  inject,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { KaspaComWebWalletService } from '../../services/wallets/kaspa-com-web-wallet.service';

@Component({
  selector: 'kcc20-kaspa-com-web-wallet-iframe',
  standalone: true,
  templateUrl: './kaspa-com-web-wallet-iframe.component.html',
  styleUrl: './kaspa-com-web-wallet-iframe.component.scss',
})
export class KaspaComWebWalletIframeComponent {
  private readonly walletService = inject(KaspaComWebWalletService);
  private readonly sanitizer = inject(DomSanitizer);

  readonly isUsingWallet = computed(() =>
    this.walletService.isUsingWalletSignal()(),
  );
  readonly showWallet = computed(() => this.walletService.showWalletSignal()());
  readonly iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    environment.kaspaComWebWalletUrl,
  );

  @ViewChild('kaspaComWebWallet')
  set webWallet(value: ElementRef<HTMLIFrameElement> | undefined) {
    this.walletService.setIframe(value?.nativeElement);
  }

  closeWallet(): void {
    void this.walletService.setShowWallet(false);
  }
}
